<template>
	<!--///////////////////////// pop 我的账户 /////////////////////////-->

	<div class="My_pop _popRight" id="POP-account" style="display: block;">
		<!-- POP -->
		<div class="pop_right" :style="{'right':isdetailopen?'640px':'0px'}">
			<!-- pop_right -->
			<ul class="pop_right_header2">
				<li>
					<h2>我的账户</h2>
				</li>
				<li>
					<btn class="pop_right_close2" name="pop-close" @click="closeFloat"></btn>
				</li>
			</ul>
			<!-- <el-skeleton :rows="20" :loading="loadingMask" animated> -->
				<div class="pop_right_main">
					<!-- main -->


					<div class="my_wrap">
						<!-- my_wrap -->
						<div class="my-header">
							<!-- my-header -->
							<div class="my-head"><span></span></div>
							<!--						<div  class="my-name">用户名</div>-->
						</div><!-- /my-header -->
						<ul class="my-notice">
							<!-- my-notice -->
							<li>
								<h2 class="read"><i></i>阅读（次）</h2>
								<h3>{{yuedu}}</h3>
							</li>
							<div class="vline"></div>
							<li>
								<h2 class="subscribe"><i></i>订阅（个）</h2>
								<h3>{{dingyue}}</h3>
							</li>
							<div class="vline"></div>
							<li>
								<h2 class="collection"><i></i>收藏（个）</h2>
								<h3>{{shoucang}}</h3>
							</li>
						</ul><!-- /my-notice -->
					</div><!-- /my_wrap -->

					<ul class="form_list">
						<li v-if="!isChangeUsername">
							<h4>用户名</h4>
							<div class="input_out">
								<div class="input_inner">
									<div class="input_box"><input type="text" class="s_input"
											v-model="completeUserinfo.username" readonly="true"></div>
								</div>
								<btn v-if="completeUserinfo.usertype=='1'||completeUserinfo.usertype=='2'"
									class="btn-edit" @click="isChangeUsername=true">修改</btn>
							</div>
						</li>
						<li v-else>
							<h4>用户名</h4>
							<div class="input_out">
								<div class="input_inner">
									<div class="input_box"><input type="text" class="s_input" v-model="newUsername"
											placeholder="请输入新的用户名"></div>
									<div class="btn_box">
										<btn class="s_btn_cancel" @click="isChangeUsername=false">取消</btn>
										<btn class="s_btn" @click="changeUsername">确认</btn>
									</div>
								</div>
								<!-- <btn class="btn-edit">修改</btn> -->
							</div>
						</li>
						<template v-if="completeUserinfo.usertype=='1'||completeUserinfo.usertype=='2'">
							<li v-if="!isChangePhone">
								<h4>绑定手机号</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box"><input type="text" class="s_input"
												v-model="completeUserinfo.tel" readonly="true"></div>
									</div>
									<btn v-if="completeUserinfo.usertype=='1'||completeUserinfo.usertype=='2'"
										class="btn-edit" @click="isChangePhone=true">修改</btn>
								</div>
							</li>
							<li v-else>
								<h4>绑定手机号</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box"><input type="text" class="s_input"  v-model="completeUserinfo.tel"  readonly="true" ></div>
										<div class="input_box"><input type="text" class="s_input" v-model="oldphonecode" placeholder="旧手机号验证码" ><btn class="s_btn"  style="margin:0;min-width: 144px;" @click="sendOldPhoneCode" :disabled="oldphonecountdown>0"  >{{oldphonecountdown?oldphonecountdown:'获取验证码'}}</btn></div>
										<div class="input_box"><input type="text" class="s_input" v-model="newPhone"
												placeholder="请输入新的手机号"></div>
										<div class="input_box"><input type="text" class="s_input" v-model="newphonecode" placeholder="新手机号验证码" ><btn class="s_btn"  style="margin:0;min-width: 144px;" @click="sendNewPhoneCode" :disabled="newphonecountdown>0"  >{{newphonecountdown?newphonecountdown:'获取验证码'}}</btn></div>
										<div class="btn_box">
											<btn class="s_btn_cancel" @click="isChangePhone=false">取消</btn>
											<btn class="s_btn" @click="changePhone">确认</btn>
										</div>
									</div>
									<!-- <btn class="btn-edit">修改</btn> -->
								</div>
							</li>
						</template>
						<template v-if="completeUserinfo.usertype=='1'||completeUserinfo.usertype=='2'">
							<li v-if="!isChangePassword">
								<h4>密码</h4>
								<div class="input_out">
									<input type="text" class="s_input" value="已设置" readonly="true">
									<btn v-if="completeUserinfo.usertype=='1'||completeUserinfo.usertype=='2'"
										class="btn-edit" @click="isChangePassword=true">修改</btn>
								</div>
							</li>
							<li v-else>
								<h4>密码</h4>
								<div class="input_out">
									<div class="input_inner">
										<!-- <div class="input_box"><input type="password" class="s_input" placeholder="旧密码"
												v-model="oldPassword"></div> -->
										<div class="input_box"><input type="password" class="s_input" placeholder="新密码"
												v-model="newPassword" @blur="checkPasswordError"></div>
										<div class="input_box" style="color: #bd1a2d;" v-show="pisweekalert" >{{pisweekalert}}</div>
										<div class="input_box">6~20个字符，可以包含字母、数字以及标点符号（除空格），建议字母、数字以及标点符号至少包含2种</div>
										<div class="input_box"><input type="password" class="s_input" placeholder="确认新密码"
												v-model="newPasswordConfirm"></div>
										<div class="input_box"><input type="text" class="s_input" v-model="pwdcode"  placeholder="请输入验证码" ><btn class="s_btn"  style="margin:0;min-width: 144px;" @click="sendPWDCode" :disabled="pwdcountdown>0" >{{pwdcountdown?pwdcountdown:'获取验证码'}}</btn></div>
										<div class="btn_box">
											<btn class="s_btn_cancel" @click="isChangePassword=false">取消</btn>
											<btn class="s_btn" @click="changePassword">确认</btn>
										</div>
									</div>
									<!-- <btn class="btn-edit">修改</btn> -->
								</div>
							</li>
						</template>
						
						<li>
							<h4>已绑定集团</h4>
							<div class="input_out">
								<div class="input_inner">
									<div class="input_box">
										<input v-if="completeUserinfo.vipGroupID&&completeUserinfo.vipGroupName" type="text" class="s_input" v-model="completeUserinfo.vipGroupName"	readonly="true">
										<input v-else-if="completeUserinfo.vipGroupID&&!completeUserinfo.vipGroupName" type="text" class="s_input" v-model="completeUserinfo.company"	readonly="true">
										<input v-else type="text" class="s_input" v-model="completeUserinfo.vipGroupName"	readonly="true">
									</div>
								</div>
								<!-- <btn
									class="btn-edit" @click="showbangding()">去认证</btn> -->
								<btn v-if="completeUserinfo.usertype=='1'&&completeUserinfo.vipGroupID==''"
									class="btn-edit" @click="showbangding()">去认证</btn>
								<btn v-else-if="completeUserinfo.usertype=='2'"
									class="btn-edit" @click="showquxiao()">取消认证</btn>
								<btn v-if="completeUserinfo.usertype=='2'"
									class="btn-edit" @click="showyanqi()">延期</btn>
							</div>
						</li>
						<template v-if="completeUserinfo.usertype=='1'||completeUserinfo.usertype=='2'||completeUserinfo.usertype=='3'">
							<li>
								<h4>账号有效期</h4>
								<div class="input_out"><input type="text" class="s_input" :value="(completeUserinfo.beginTime?completeUserinfo.beginTime.substring(0,10):'')+' ~ '+(completeUserinfo.endTime?completeUserinfo.endTime.substring(0,10):'')" readonly="true"></div>
							</li>
						</template>
						
					</ul>

				</div><!-- /main -->
			<!-- </el-skeleton> -->
			<!-- <div class="pop_right_footer2">
					<btn class="s_btn"   >提交</btn>
			</div> -->
		</div><!-- /pop_right -->
		<div class="pop_bg" style="display: block;" @click="closeFloat"></div>
		
		<el-dialog :visible.sync="isBDJT" :close-on-click-modal="true" :close-on-press-escape="false" :modal="false" width="1107px" >
		  <floatad></floatad>
		</el-dialog>
		
	</div><!-- /POP -->


</template>

<script>
	import md5 from 'js-md5';
	export default {
		data() {
			return {
				loadingMask:false,
				completeUserinfo:'',
				yuedu: 0,
				dingyue: 0,
				shoucang: 0,
				isChangeUsername: false,
				isChangePhone: false,
				isChangePassword: false,
				isYQJT:false,
				isQXJT:false,
				isBDJT:false,
				newUsername: '',
				newPhone: '',
				oldphonecode:'',
				oldphonecountdown:0,
				oldphonetimer:'',
				newphonecode:'',
				newphonecountdown:0,
				newphonetimer:'',
				oldPassword:'',
				newPassword: '',
				newPasswordConfirm: '',
				pisweekalert:'',
				pwdcode:'',
				pwdcountdown:0,
				pwdtimer:'',
			}
		},
		props: [
			'userinfo',
			'isdetailopen'
		],
		mounted: function() {
			this.getuserinfofnc();
			this.getAllCount();
			if(this.$cookies.get('pwdcountdown')&&parseInt(this.$cookies.get('pwdcountdown'))){
				this.setCountdown(parseInt(this.$cookies.get('pwdcountdown')));
			}
			if(this.$cookies.get('oldphonecountdown')&&parseInt(this.$cookies.get('oldphonecountdown'))){
				this.setOldPhoneCountdown(parseInt(this.$cookies.get('oldphonecountdown')));
			}
			if(this.$cookies.get('newphonecountdown')&&parseInt(this.$cookies.get('newphonecountdown'))){
				this.setNewPhoneCountdown(parseInt(this.$cookies.get('newphonecountdown')));
			}
			this.$track([
				['pagetype','我的账户']
			]);
		},
		methods: {
			showbangding:function(){
				this.$emit('showbangding',this.userinfo);
			},
			showquxiao:function(){
				this.$emit('showquxiao',this.userinfo);
			},
			showyanqi:function(){
				this.$emit('showyanqi',this.userinfo);
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
			getuserinfofnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'UserInfo/getUserInfo',
						responseType: 'json',
						params: {

						},
					})
					.then(function(response) {
						_this.completeUserinfo = response.data.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			getAllCount: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/GetUserReadCount',
						responseType: 'json',
						params: {
							userid: this.userinfo ? this.userinfo.userAccountID : '',
						},
					})
					.then(function(response) {
						_this.yuedu = response.data.data.data.sReadCount;
						_this.dingyue = response.data.data.data.sOrdersCount;
						_this.shoucang = response.data.data.data.sFavoritesCount;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			checkisPhone:function(s){
				var regexp = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
				return regexp.test(s);
			},
			changeUsername:function(){
				if(this.newUsername){
					
					//230426添加规则，用户名不能为纯数字
					var re=/^[0-9]*$/;
					if(re.test(this.newUsername)){
						this.$message({
							message: '用户名不能为纯数字',
							type: 'warning'
						});
						return false
					}
					
					let _this = this;
					_this.loadingMask = true;
					this.$http({
							method: 'post',
							url: 'UserInfo/ModifyAccount',
							responseType: 'json',
							params: {
								Account:this.newUsername
							},
						})
						.then(function(response) {
							if(response.data.code==20000){
								_this.$message({
									message: response.data.data.msg,
									type: 'success'
								});
								_this.isChangeUsername=false;
								_this.getuserinfofnc();
							}
							else{
								_this.$message({
									message: response.data.data.msg,
									type: 'warning'
								});
							}
							_this.loadingMask = false;
						})
						.catch(function(error) {
							_this.loadingMask = false;
							console.log(error);
						});
				}
				else{
					this.$message({
						message: '请填写新用户名',
						type: 'warning'
					});
				}
			},
			setOldPhoneCountdown:function(num){
				let _this = this;
				_this.oldphonecountdown=num;
				clearInterval(_this.oldphonetimer);
				_this.oldphonetimer=setInterval(function(){
					// debugger;
					if(_this.oldphonecountdown>1){
						_this.oldphonecountdown--;
						_this.$cookies.set('oldphonecountdown',_this.oldphonecountdown,_this.oldphonecountdown);
					}
					else{
						_this.oldphonecountdown=0;
						clearInterval(_this.oldphonetimer);
						_this.$cookies.remove('oldphonecountdown');
					}
				},1000);
			},
			setNewPhoneCountdown:function(num){
				let _this = this;
				_this.newphonecountdown=num;
				clearInterval(_this.newphonetimer);
				_this.newphonetimer=setInterval(function(){
					// debugger;
					if(_this.newphonecountdown>1){
						_this.newphonecountdown--;
						_this.$cookies.set('newphonecountdown',_this.newphonecountdown,_this.newphonecountdown);
					}
					else{
						_this.newphonecountdown=0;
						clearInterval(_this.newphonetimer);
						_this.$cookies.remove('newphonecountdown');
					}
				},1000);
			},
			sendOldPhoneCode:function(){
				let _this = this;
				if(_this.oldphonecountdown>0){
					_this.$message({
						message: '不可频繁发送验证码',
						type: 'warning'
					});
					return false;
				}
				if(_this.completeUserinfo.tel){
					_this.oldphonecountdown=60;
					_this.loadingMask = true;
					this.$http({
							method: 'post',
							url: 'UserInfo/getChangPhoneCodeInfo',
							responseType: 'json',
							params: {
								
							},
						})
						.then(function(response) {
							
							if(response.data.code==20000){
								_this.$message({
									message: response.data.data.msg,
									type: 'success'
								});
								_this.setOldPhoneCountdown(60);
							}
							else{
								_this.$message({
									message: '发送失败',
									type: 'warning'
								});
								_this.oldphonecountdown=0;
							}
							_this.loadingMask = false;
						})
						.catch(function(error) {
							_this.oldphonecountdown=0;
							_this.loadingMask = false;
							console.log(error);
						});
				}
				else{
					this.$message({
						message: '未找到绑定手机号',
						type: 'warning'
					});
				}
			},
			sendNewPhoneCode:function(){
				let _this = this;
				if(_this.newphonecountdown>0){
					_this.$message({
						message: '不可频繁发送验证码',
						type: 'warning'
					});
					return false;
				}
				if(_this.newPhone&&_this.checkisPhone(_this.newPhone)){
					_this.newphonecountdown=60;
					_this.loadingMask = true;
					this.$http({
							method: 'post',
							url: 'UserInfo/getChangPhoneCodeInfo',
							responseType: 'json',
							params: {
								newPhone:this.newPhone
							},
						})
						.then(function(response) {
							if(response.data.code==20000){
								_this.$message({
									message: response.data.data.msg,
									type: 'success'
								});
								_this.setNewPhoneCountdown(60);
							}
							else{
								_this.$message({
									message: '发送失败',
									type: 'warning'
								});
								_this.newphonecountdown=0;
							}
							_this.loadingMask = false;
						})
						.catch(function(error) {
							_this.newphonecountdown=0;
							_this.loadingMask = false;
							console.log(error);
						});
				}
				else{
					this.$message({
						message: '请填写正确的手机号',
						type: 'warning'
					});
				}
			},
			changePhone:function(){
				if(this.newPhone&&this.checkisPhone(this.newPhone)&&this.oldphonecode&&this.newphonecode){
					let _this = this;
					_this.loadingMask = true;
					this.$http({
							method: 'post',
							url: 'UserInfo/getChangPHCodeInfo',
							responseType: 'json',
							params: {
								oldPhone:this.completeUserinfo.tel,
								newPhone:this.newPhone,
								oldPhoneCode:this.oldphonecode,
								newPhoneCode:this.newphonecode,
							},
						})
						.then(function(response) {
							if(response.data.code==20000){
								//验证通过后直接修改
								_this.$http({
										method: 'post',
										url: 'UserInfo/editMobile',
										responseType: 'json',
										params: {
											Mobile:_this.completeUserinfo.tel,
											NewMobile:_this.newPhone,
										},
									})
									.then(function(response) {
										if(response.data.code==20000){
											_this.$message({
												message: response.data.data.msg,
												type: 'success'
											});
											_this.isChangePhone=false;
											_this.getuserinfofnc();
										}
										else{
											_this.$message({
												message: response.data.data.msg,
												type: 'warning'
											});
										}
										_this.loadingMask = false;
									})
									.catch(function(error) {
										_this.loadingMask = false;
										console.log(error);
									});
							}
							else{
								_this.$message({
									message: response.data.data.msg,
									type: 'warning'
								});
								_this.loadingMask = false;
							}
						})
						.catch(function(error) {
							_this.loadingMask = false;
							console.log(error);
						});
				}
				else{
					this.$message({
						message: '请填写正确的手机号及验证码',
						type: 'warning'
					});
				}
			},
			setCountdown:function(num){
				let _this = this;
				_this.pwdcountdown=num;
				clearInterval(_this.pwdtimer);
				_this.pwdtimer=setInterval(function(){
					// debugger;
					if(_this.pwdcountdown>1){
						_this.pwdcountdown--;
						_this.$cookies.set('pwdcountdown',_this.pwdcountdown,_this.pwdcountdown);
					}
					else{
						_this.pwdcountdown=0;
						clearInterval(_this.pwdtimer);
						_this.$cookies.remove('pwdcountdown');
					}
				},1000);
			},
			sendPWDCode:function(){
				let _this = this;
				if(_this.pwdcountdown>0){
					_this.$message({
						message: '不可频繁发送验证码',
						type: 'warning'
					});
					return false;
				}
				if(_this.completeUserinfo.tel){
					_this.pwdcountdown=60;
					_this.loadingMask = true;
					this.$http({
							method: 'post',
							url: 'UserInfo/getChangPWDCodeInfo',
							responseType: 'json',
							params: {
								
							},
						})
						.then(function(response) {
							if(response.data.code==20000){
								_this.$message({
									message: response.data.data.msg,
									type: 'success'
								});
								_this.setCountdown(60);
							}
							else{
								_this.$message({
									message: '发送失败',
									type: 'warning'
								});
								_this.pwdcountdown=0;
							}
							_this.loadingMask = false;
						})
						.catch(function(error) {
							_this.pwdcountdown=0;
							_this.loadingMask = false;
							console.log(error);
						});
				}
				else{
					this.$message({
						message: '未找到绑定手机号',
						type: 'warning'
					});
				}
			},
			checkPasswordError:function(){
				// debugger;
				var pisweek=true;
				this.pisweekalert='';
				var strongRegex = new RegExp("^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g");
				var mediumRegex = new RegExp("^(?=.{7,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$", "g");
				var enoughRegex = new RegExp("(?=.{6,}).*", "g");
				if (isNameInPwd(this.completeUserinfo.username, this.newPassword) ) {
						pisweek = true;
						this.pisweekalert='密码中包含用户名，请重新设置!';
				} else if (isInweek(this.newPassword)) {
						pisweek = true;
						this.pisweekalert='密码强度弱!';
				} else if (false == enoughRegex.test(this.newPassword)) {
						pisweek = true;
						this.pisweekalert='字符太短!';
				} else if (strongRegex.test(this.newPassword)) {
						pisweek = false;
						// this.pisweekalert='密码强度强!';
				} else if (mediumRegex.test(this.newPassword)) {
						pisweek = false;
						// this.pisweekalert='密码强度中!';
				} else {
						pisweek = true;
						this.pisweekalert='密码强度弱!';
				}
				return pisweek;
			},
			changePassword:function(){
				if (this.newPassword.trim().length == 0) {
					this.$message({
						message: '请输入验证码！',
						type: 'warning'
					});
						return false;
				}
				if (this.newPassword.length < 6) {
					this.$message({
						message: '密码长度小于6位，请输入大于6位长度的密码！',
						type: 'warning'
					});
						return false;
				}
				if ( this.newPassword.length == 0 || this.newPasswordConfirm.length == 0) {
					this.$message({
						message: '请输入密码信息！',
						type: 'warning'
					});
						return false;
				}
				if (this.checkPasswordError() == true) {
					this.$message({
						message: '密码强度太弱，请设置更复杂密码，如数字+字母+特殊字符，而且长度大于6位！',
						type: 'warning'
					});
						return false;
				}
				if (this.newPassword != this.newPasswordConfirm) {
					this.$message({
						message: '新密码两次输入不一致！',
						type: 'warning'
					});
						return false;
				}
				
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/editPwd',
						responseType: 'json',
						params: {
							NewPassword:md5(this.newPassword),
							PwdCode:this.pwdcode
						},
					})
					.then(function(response) {
						if(response.data.code==20000){
							_this.$message({
								message: response.data.data.msg,
								type: 'success'
							});
							_this.newPassword='';
							_this.newPasswordConfirm='';
							_this.pwdcode='';
							_this.isChangePassword=false;
						}
						else{
							_this.$message({
								message: response.data.data.msg,
								type: 'warning'
							});
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
		},
	}
</script>

<style>
</style>
